import React from "react";

import { Divider, Stack } from "@mui/material";

import SettingsTitle from "../../components/SettingsTitle";
import SettingSwitch from "../../components/SettingSwitch";

interface OnOffSettingProps {
  title: string;
  subtitle?: string;
  isOn: boolean;
  locked: boolean;
  bottomDivider?: boolean;
  onChange: (settingIsOn: boolean) => void;
  tooltip?: string;
}

const OnOffSetting = ({
  title,
  subtitle,
  locked,
  isOn,
  onChange,
  bottomDivider,
  tooltip,
}: OnOffSettingProps) => {
  return (
    <Stack direction="column">
      <Stack direction="row" sx={{ minHeight: "42px" }}>
        <SettingsTitle
          title={title}
          subtitle={subtitle}
          sx={{ width: "100%" }}
        />
        <SettingSwitch
          isOn={isOn}
          locked={locked}
          onChange={onChange}
          tooltip={tooltip}
        />
      </Stack>
      {bottomDivider && <Divider sx={{ pb: 1 }} />}
    </Stack>
  );
};

export default OnOffSetting;
